import { render, staticRenderFns } from "./GenericCard.vue?vue&type=template&id=a3d50f1a&"
import script from "./GenericCard.ts?vue&type=script&lang=ts&"
export * from "./GenericCard.ts?vue&type=script&lang=ts&"
import style0 from "./GenericCard.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports